import WaitingListReport from "./WaitingListReport";
const Reports = () => {
    return(
        <>
           <WaitingListReport/>
        </>
    )
}

export default Reports;